export const applyCollectionFieldChange = (items, itemId, fieldName, value) => {
  const next = [...(items || [])];
  const index = next.findIndex((item) => item && item.id === itemId);
  if (index < 0) {
    next.push({ id: itemId, [fieldName]: value });
    return next;
  }
  next[index] = { ...next[index], [fieldName]: value };
  return next;
};
